module.exports = __webpack_public_path__ + "static/media/image_47.ab6ed7d4.png";